import script from "./YSerialPortView.vue?vue&type=script&setup=true&lang=js"
export * from "./YSerialPortView.vue?vue&type=script&setup=true&lang=js"

import "./YSerialPortView.vue?vue&type=style&index=0&id=6b1516a6&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-6b1516a6"]])

export default __exports__